import axios from "axios";
import {urlAddFileToInscription, urlRemoveFileFromInscription, urlAddFileToRejectedRequirements, urlRemoveFileFromRejectedRequirements } from "./services.config";

export const addFileToInscription = function (data: any) {
    const formData = new FormData();
    Object.entries(data).forEach(key => formData.append(key[0], (key[1] as any)));
    return new Promise((resolve, reject) => {
        axios.post(urlAddFileToInscription(data.inscriptionId), formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response: any) => resolve(response.data))
            .catch((error: any) => reject(error));
    })
}

export const removeFileFromInscription = function (inscriptionId: string, fileId: string) {
    return new Promise((resolve, reject) => {
        axios.delete(urlRemoveFileFromInscription(inscriptionId, fileId))
            .then((response: any) => resolve(response.data))
            .catch((error: any) => reject(error));
    })
}

export const addFileToRejectedRequirement = function (data: any, nif: string) {
    const formData = new FormData();
    Object.entries(data).forEach(key => {
        if (key[1] != null) {
            formData.append(key[0], (key[1] as any))
        }
    });
    return new Promise((resolve, reject) => {
        axios.post(urlAddFileToRejectedRequirements(nif, data.inscriptionId), formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response: any) => resolve(response.data))
            .catch((error: any) => reject(error));
    })
}
